import React from "react";
import {
    RichTextField,
    ArrayField,
    SimpleFormIterator,
    TextField,
    Tab,
    FormTab,
    Datagrid,
    DatagridBody,
    BooleanField,
    useResourceContext,
    FormDataConsumer,
    choices,
    useRecordContext,
    NumberInput} from "react-admin";

import { Box, Table, TableRow, TableCell, Typography, Divider, Chip } from '@mui/material';
import { ArrayInput, BooleanInput, TextInput } from "../../../lib/wrappers/Inputs";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";

var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

var titleStyle = { color: "#AE223F" }

export const LearningAndTeachingTabsInputTab = (source) =>{
    const resource = useResourceContext();

    return (<FormTab label='myroot.learningAndTeaching' {...source}>
        <Box display="flex" width={1}>
            <Box flex={4}>
                <Typography variant="h6" style={titleStyle} sx={{marginBottom: '15px'}}>
                    Module | <small><TextField source="id" label={false} /></small> | <small><TextField source="shortTitle" label={false} /></small>
                </Typography>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Learning and Teaching / Learning Outcomes" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" sx={{ width: 1 }}>
            <Box flex={2}>
            <ArrayInput source="learningAndTeachingMethods" fullWidth>
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                        {({ getSource, scopedFormData }) =>
                            <Box display="flex" width={1}>
                                <Box flex={4}>
                                    <TextInput source={getSource("description")} fullWidth />
                                </Box>
                                <Box flex={1} ml="0.5em">
                                    <TextInput source={getSource("numberOfHours")} label="Number of Hours" fullWidth />
                                </Box>
                            </Box>
                        }
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
                <CountHours {...source} />
            </Box>
            <Box flex={3} ml="1.5em">
                <ArrayInput source="moduleLearningOutcomes" fullWidth validate={moduleLearningOutcomesValidation}>
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                            {({ getSource, scopedFormData }) =>
                                <Box display="flex" width={1}>
                                    <Box flex={1}>
                                        <TextInput source={getSource("id")} disabled />
                                    </Box>
                                    <Box flex={8} ml="0.5em">
                                        <TextInput source={getSource("Title")} label="Learning Outcome" multiline fullWidth />
                                    </Box>
                                </Box>
                            }
                        </FormDataConsumer>
                    </SimpleFormIterator>
                </ArrayInput>
            </Box>
        </Box>
        <TextInput source="learningAndTeachingDescription" fullWidth />
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Key Skills" /></b></Divider>
            </Box>
        </Box>  
        <Box display="flex" width={1}>
            <Box flex={1}>
                <ArrayInput source="moduleKeySkills" fullWidth >
                <SimpleFormIterator disableReordering fullWidth>
                    <FormDataConsumer>
                            {({ getSource, scopedFormData }) =>
                                <Box display="flex" width={1}>
                                    <Box flex={1}>
                                        <NumberInput source={getSource("category")} label="Id" disabled fullWidth/>
                                    </Box>
                                    <Box flex={10} ml="0.5em">
                                        <TextInput source={getSource("description")} label="Title" multiline fullWidth />
                                    </Box>
                                </Box>
                            }
                        </FormDataConsumer>
                    </SimpleFormIterator>
                </ArrayInput>
            </Box>
        </Box>
        
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Graduate Attributes" /></b></Divider>
            </Box>
        </Box>
              
        <Box>
           
            <BooleanInput source="gA1CommercialAwareness" label="GA1 CommercialAwareness" />
            <BooleanInput source="gA2Communication" label="GA2 Comunication" />
            <BooleanInput source="gA3Leadership" label="GA3 Leadership" />
            <BooleanInput source="gA4InnovationandEnt" label="GA4 Innovation And Enterpise" />
            <BooleanInput source="gA5ProjectManagement" label="GA5 Project Management" />
            <BooleanInput source="gA6DigitalLiteracy" label="GA6 Digital Literacy" />
        </Box>
        
        {resource === "Module" &&
            <VersioningTypeInput source="versioningType" resource={resource} />
        }
    </FormTab>
    );
}
   
const CountHours = ({methods}) =>{
const record = useRecordContext();
    return (
        <div style={{marginTop: "-20px", float: "right" }}>
            {record ? <div>
                <Chip label={record.learningAndTeachingMethods ?
                    getHours(record.learningAndTeachingMethods)
                    : null}>
                </Chip>
                
            </div> : null}
        </div>
    );

} 

const getHours = (methods) => {
    if(methods !== null && methods !== undefined && methods.length !== 0)
    {
        var hours = 0;
        methods?.forEach(element => {
            hours = hours + parseInt(element.numberOfHours, 10);
        });
        return (<span>Hours: {hours}</span>);
    }
    return "";
}


const validateValidation = choices(['validated', 'modified', 'corrected'], 'Please check the forms mandatory fields are complete');

var Index = 0;
const NumberedDataGridRow = ({ record, resource, children, basePath }) => (

    <TableRow>
        <TableCell>
            {Index = Index + 1}
        </TableCell>
        {React.Children.map(children, field => (
            <TableCell>
                {React.cloneElement(field, {
                    record,
                    basePath,
                    resource,
                })}
            </TableCell>
        ))}
    </TableRow>
);

const NumberedDataGridBody = props => <DatagridBody {...props} row={<NumberedDataGridRow />} {...Index = 0} />;
const NumberedDataGrid = props => <Datagrid {...props} body={<NumberedDataGridBody />} />;

const moduleLearningOutcomesValidation = (message = 'Maximum number of 10 learning outcomes', value) => {
    if (value && value.length > 10) {
        return message;
    }
}

function getVal(bool) {
    if (bool) {
        return (<span>&#10004;</span>)
    }
    else {
        return (<span>&#10006;</span>)
    }
}
